///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { navbarRoute } from './app.route';
import { errorRoute } from './layouts/error/error.route';

const LAYOUT_ROUTES = [...navbarRoute, ...errorRoute];

@NgModule({
    imports: [RouterModule.forRoot(LAYOUT_ROUTES, { useHash: true, bindToComponentInputs: true })],
    exports: [RouterModule]
})
export class GtthAppRoutingModule {}
